import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import * as moment from 'moment';
import { takeUntil } from 'rxjs/operators';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { BreakModalService } from '../break-modal/break-modal-service/break-modal.service';
import { VehicleInspectionService } from 'src/app/component/reports/inspection/vehicle-inspection-service/vehicle-inspection.service';

@Component({
  selector: 'app-odometer-modal',
  templateUrl: './odometer-modal.component.html',
  styleUrls: ['./odometer-modal.component.css']
})
export class OdometerModalComponent implements OnInit {
 odometerForm: UntypedFormGroup
  timeZone;
  user
  submitted = false;
  @Input() data;
  @Output() closeModal = new EventEmitter<any>()
  constructor(
    private fb: UntypedFormBuilder,
    private sharedDataService: SharedDataService,
    private vehicleInspectionService: VehicleInspectionService,
    ) { }

  ngOnInit() {
    this.odometerForm = this.fb.group({
      odmReading: [''],
      odmEndReading:['']
    });

    this.getUser();
  }

  getUser() {
    this.sharedDataService.getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.user = data;
          this.timeZone = this.user.timeZone;
        }
      });
    this.odometerDetails();
  }

  odometerDetails(){
    if(this.data){
      this.odometerForm.patchValue({
        ...this.data
      })
    }
  }



// update


  onCreate() {
    this.submitted = true;
    if (this.odometerForm.invalid){
      return;
    }
    const payload = this.odometerForm.value;
    console.log("Payload check",payload);

    this.vehicleInspectionService.updateOdometer(payload, this.data._id).pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data=>{
      if(data){
        this.closeModal.emit(data);
      }
    })


  }


  onCloseModal() {
    this.closeModal.emit(false)
  }

  get form() {
    return this.odometerForm.controls;
  }

  ngOnDestroy(): void {
  }
}
